import { useLocation } from "react-router-dom";
import avatarTemplate from "../assets/images/avatar.png";

export function printLog(message) {
  console.log(message + "..." + console.trace());
}

export function convertPersianNumbersToEnglish(persianDate) {
  const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  return persianDate.replace(/[۰-۹]/g, (char) => {
    return englishNumbers[persianNumbers.indexOf(char)];
  });
}

export function formatNumber(number, exp = 2) {
  return Number(Number(number ?? 0)?.toFixed(exp)).toLocaleString("en-us");
}

export function getRandomNumber(min = 0, max = 99999999) {
  const rand = Math.ceil(min + Math.random() * (max - min));
  return rand;
}

export function getSizeString(size) {
  if (size < 1024) return "کمتر از یک کیلوبایت";
  else if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} کیلوبایت`;
  else if (size < 1024 * 1024 * 1024)
    return `${(size / (1024 * 1024)).toFixed(2)} مگابایت`;
  else return "نا مشخص";
}

export function debounce(func, timeParam) {
  let time = timeParam || 100; // 100 by default if no param
  let timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, time, event);
  };
}

export function areArraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

export function getQueryStringParams(qs) {
  if (!qs) {
    return [];
  }
  let params = qs?.split("&");

  let result = {};
  params?.forEach((p) => {
    if (p) {
      let param = p.split("=");
      if (param?.at(0) && param?.at(1)) {
        result[param?.at(0)?.toLowerCase()] = param?.at(1);
      }
    }
  });
  return result;
}

export function getQSParamsHash(hash) {
  if (!hash) {
    return [];
  }
  let qs = hash?.substring(hash?.indexOf("?") + 1);
  let params = qs?.split("&");

  let result = {};
  params?.forEach((p) => {
    if (p) {
      let param = p.split("=");
      if (param?.at(0) && param?.at(1)) {
        result[param?.at(0).toLowerCase()] = param?.at(1);
      }
    }
  });
  return result;
}

/**
 *
 * @returns یک ابجت که پراپرتی های ان لوورکیس کوئری استرینگ (بعد از هش) و مقدار پراپرتی، مقدار کوئری استرینگ هست
 *
 *
 * ```ts
 * Url: &SearchTerm=HlEllo
 * {
 *   searchterm:HlEllo
 * }
 * ```
 */
export function useHashSearch() {
  const location = useLocation();

  return getQSParamsHash(location?.hash) ?? {};
}

/**
 *
 * @returns یک ابجت که پراپرتی های ان لوورکیس کوئری استرینگ و مقدار پراپرتی، مقدار کوئری استرینگ هست
 *
 *
 * ```ts
 * Url: &SearchTerm=HlEllo
 * {
 *   searchterm:HlEllo
 * }
 * ```
 */
export function useSearch() {
  const location = useLocation();
  let qs = location?.search?.substring(1);
  return getQueryStringParams(qs) ?? {};
}

export function landscapePrint(head, body) {
  let newWin = window.open();
  head = head[0].getElementsByTagName("style");
  let styles = [...head]?.map((x) => x.outerHTML).join(" ");
  let link = head[0].getElementsByTagName("link");
  let links = [...link]?.map((x) => x.outerHTML).join(" ");
  console.log(styles);
  console.log(links);

  newWin.document.write("<html>");
  newWin.document.write("<head>");
  newWin.document.write("<style> ");
  newWin.document.write(
    " .landscape {width: calc(100vh - 20px);height: calc(100vw - 20px); margin:10px ;transform: rotate(270deg) translate(calc(20px - 100vh), 0);transform-origin: 0 0;}"
  );
  newWin.document.write(
    " .paper {position: absolute;left: 0;top: 0;right: 0;bottom: 0;} "
  );
  newWin.document.write("   ");
  newWin.document.write(" </style> ");
  newWin.document.write(styles);
  newWin.document.write(links);
  newWin.document.write("</head>");
  newWin.document.write('<body class="d-grid   landscape">');
  newWin.document.write(body);
  newWin.document.write("</body>");
  newWin.document.write("</html>");
  newWin.document.close();
  newWin.focus();
  setTimeout(() => {
    newWin.print();
  }, 500);
}

export function portratePrint(head, body) {
  let newWin = window.open();
  head = head[0].getElementsByTagName("style");
  let styles = Array.from(head)
    ?.map((x) => x.outerHTML)
    .join(" ");
  let link = head[0].getElementsByTagName("link");
  let links = [...link]?.map((x) => x.outerHTML).join(" ");
  console.log(styles);
  console.log(links);
  newWin.document.write("<html>");
  newWin.document.write("<head>");

  newWin.document.write("<style> ");
  newWin.document.write(
    " .landscape {width: calc(100vh - 20px);height: calc(100vw - 20px); margin:10px ; }"
  );
  newWin.document.write(
    " .paper {position: absolute;left: 0;top: 0;right: 0;bottom: 0;} "
  );
  newWin.document.write("   ");
  newWin.document.write(" </style> ");
  newWin.document.write(styles);
  newWin.document.write(links);
  newWin.document.write("</head>");
  newWin.document.write('<body class="d-grid   ">');
  newWin.document.write(body);
  newWin.document.write("</body>");
  newWin.document.write("</html>");
  newWin.document.close();
  newWin.focus();
  setTimeout(() => {
    newWin.print();
  }, 500);
}

export function formatBytes(a, b = 2) {
  if (!+a) return "";
  const c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024));
  return `${parseFloat((a / Math.pow(1024, d)).toFixed(c))} ${
    ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
  }`;
}

export async function downloadFileWithAnchor(response) {
  const blob = await response?.data;
  const fileName = decodeURIComponent(
    response.headers["content-disposition"].split("filename*=UTF-8''")[1]
  );
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;

  link.setAttribute("download", fileName); // نام فایل برای دانلود
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
}

export const msToTime = (ms) => {
  // تعداد میلی‌ثانیه‌ها در یک روز، ساعت، دقیقه، و ثانیه
  const msPerDay = 24 * 60 * 60 * 1000;
  const msPerHour = 60 * 60 * 1000;
  const msPerMinute = 60 * 1000;
  const msPerSecond = 1000;

  // محاسبه تعداد روزها
  const days = Math.floor(ms / msPerDay);
  ms %= msPerDay;

  // محاسبه تعداد ساعت‌ها
  const hours = Math.floor(ms / msPerHour);
  ms %= msPerHour;

  // محاسبه تعداد دقیقه‌ها
  const minutes = Math.floor(ms / msPerMinute);
  ms %= msPerMinute;

  // محاسبه تعداد ثانیه‌ها
  const seconds = Math.floor(ms / msPerSecond);

  return `${hours}:${minutes}${days ? ` - روز ${days}` : ""}`;
};

export const secondsToTime = (secs) => {
  // تعداد میلی‌ثانیه‌ها در یک روز، ساعت، دقیقه، و ثانیه
  const sPerDay = 24 * 60 * 60;
  const sPerHour = 60 * 60;
  const sPerMinute = 60;
  const sPerSecond = 1;

  // محاسبه تعداد ساعت‌ها
  const hours = Math.floor(secs / sPerHour);
  secs %= sPerHour;

  // محاسبه تعداد دقیقه‌ها
  const minutes = Math.floor(secs / sPerMinute);
  secs %= sPerMinute;

  // محاسبه تعداد ثانیه‌ها
  const seconds = Math.floor(secs / sPerSecond);

  return `${hours}:${minutes.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })}:${seconds.toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })}`;
};
export function trimEnd(str, ending) {
  if (str.toLowerCase().endsWith(ending.toLowerCase())) {
    return str.slice(0, -ending.length);
  }
  return str;
}

/**
 * 
 * @param prefix به همراه اسلش اول .
 * 
 نام ابجکت و کویری یکی باشد
 * @returns  تبدیل آبجک به querystring به همراه "؟" اول 
 */
export const generateQueryString = (prefix, obj, sendZeros = false) => {
  if (!obj) return "";

  let result = "?";

  Object.entries(obj)?.forEach((x) => {
    if (x[1] || (x[1]?.toString() === "0" && sendZeros)) {
      result += convertToEnglishDigits(`${x[0].toLowerCase()}=${x[1]}&`);
    }
  });

  return trimEnd(`${prefix}${result}`, "&");
};
function convertToEnglishDigits(str) {
  return str
    .replace(/[۰-۹]/g, (d) => d.charCodeAt(0) - 1776) // Persian digits
    .replace(/[٠-٩]/g, (d) => d.charCodeAt(0) - 1632); // Arabic digits
}
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(reader.result);
    reader.readAsDataURL(file);
    reader.onerror = reject;
  });

/**
 * get base64 image
 */
export const getDefaultAvatar = async () => {
  const response = await fetch(avatarTemplate);
  const blob = await response.blob();
  const base64 = await fileToBase64(blob);
  return base64;
};

export const getBase64ProfileImage = (base64Image, type = "png") => {
  if (!base64Image) {
    return avatarTemplate;
  }

  if (!base64Image?.startsWith("data:image")) {
    base64Image += `data:image/${type};base64,${base64Image}`;
  }

  return base64Image;
};
